export const UPDATE_CURRENT_STEP = 'UPDATE_CURRENT_STEP';
export const UPDATE_BOTTLES = 'UPDATE_BOTTLES';
export const UPDATE_FLOW_RATE = 'UPDATE_FLOW_RATE';
